// "오늘 하루 동안 안보기"(사전 공지 모달) 상태 저장.
// 식별자는 notice_period.modified_at, 날짜는 사용자 로컬(KST) 날짜 기준.

const DISMISSAL_KEY = 'officemail.maintenance.noticeDismissal'

interface NoticeDismissal {
  modifiedAt: string
  dismissedDate: string
}

// 이번 페이지 로드(세션) 동안 그냥 닫은 공지의 modified_at.
// 새로고침하면 모듈이 다시 평가되어 null 로 초기화된다(= 다음 로드에 재노출).
// 인증 완료(authorized false→true)에 따른 재평가가 같은 로드 내에서 공지를 되살리는 것을 막는다.
let sessionDismissedModifiedAt: string | null = null

/** 이번 세션 동안 해당 공지를 닫음으로 기록(체크박스 무관, 닫기 시 항상 호출). */
export function dismissNoticeForSession(modifiedAt: string): void {
  sessionDismissedModifiedAt = modifiedAt
}

/** 로컬 타임존 기준 YYYY-MM-DD (UTC 변환 아님). */
export function toLocalDateString(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

function readDismissal(): NoticeDismissal | null {
  try {
    const raw = localStorage.getItem(DISMISSAL_KEY)
    return raw ? (JSON.parse(raw) as NoticeDismissal) : null
  } catch {
    return null
  }
}

/** 이번 세션에 닫았거나(메모리) 같은 modified_at 으로 오늘 이미 닫았으면(localStorage) true → 모달 스킵. */
export function isNoticeDismissed(modifiedAt: string, now: Date): boolean {
  if (sessionDismissedModifiedAt === modifiedAt) return true
  const stored = readDismissal()
  if (!stored) return false
  return stored.modifiedAt === modifiedAt && stored.dismissedDate === toLocalDateString(now)
}

/** "오늘 하루 안보기" 저장. modified_at 이 바뀌면 다음에 다시 노출된다. */
export function dismissNoticeForToday(modifiedAt: string, now: Date): void {
  try {
    const value: NoticeDismissal = { modifiedAt, dismissedDate: toLocalDateString(now) }
    localStorage.setItem(DISMISSAL_KEY, JSON.stringify(value))
  } catch {
    // 저장 불가 시 무시(다음 평가에 다시 노출될 뿐).
  }
}

/** dismissal 상태(오늘 안보기 localStorage + 세션 닫음 메모리) 제거. dev 시나리오에서 공지를 다시 띄울 때 사용. */
export function clearNoticeDismissal(): void {
  sessionDismissedModifiedAt = null
  try {
    localStorage.removeItem(DISMISSAL_KEY)
  } catch {
    // 삭제 불가 시 무시.
  }
}
